import Head from 'next/head';
import { useFlags } from 'launchdarkly-react-client-sdk';

import useParams from 'legacy/common/hooks/useParams';

import { FLAGS } from 'legacy/common/constants/launchdarkly';

import SignUp from 'legacy/auth/screens/SignUp.screen';
import PhoneRegister from 'legacy/auth/screens/legacy/PhoneRegister.screen';
import EmailRegister from 'legacy/auth/screens/legacy/EmailRegister.screen';
import Loader from 'legacy/common/components/layout/Loader';

type RegisterPageParams = {
  type: 'email' | 'phone';
};

const registerType = {
  phone: <PhoneRegister />,
  email: <EmailRegister />
};

export const RegisterPage = () => {
  const flags = useFlags();
  const params = useParams<RegisterPageParams>();

  if (!(FLAGS.ENABLE_NEW_SIGN_UP_FLOW in flags)) {
    return <Loader isLoading />;
  }

  return (
    <>
      <Head>
        <title>Bounce</title>
      </Head>

      {flags[FLAGS.ENABLE_NEW_SIGN_UP_FLOW] ? (
        <SignUp />
      ) : (
        registerType[params?.type] || registerType.email
      )}
    </>
  );
};

export default RegisterPage;
